import { FormattedMessage, useIntl } from 'react-intl';
import Button from '@mui/material/Button';
import LockIcon from '@mui/icons-material/Lock';
import ConfirmationModal from '~/components/ConfirmationModal';
import appMessages from '~/containers/App/messages';
import messages from './messages';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import { useLockPublisher } from '~/hooks/api/useLockPublisher';

import { useState } from 'react';

type LockButtonProps = {
  publisherId: number;
};

export const LockButton = (props: LockButtonProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const [isConfirmationDialogVisible, setIsConfirmationDialogVisible] =
    useState(false);
  const lockPublisherMutation = useLockPublisher({
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.lockSuccess),
      });
    },
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.lockFailure),
      });
    },
    onSettled() {
      setIsConfirmationDialogVisible(false);
    },
  });
  return (
    <>
      <Button
        onClick={() => setIsConfirmationDialogVisible(true)}
        startIcon={<LockIcon />}
        data-test="lock-button"
      >
        {intl.formatMessage(messages.lockUser)}
      </Button>

      <ConfirmationModal
        open={isConfirmationDialogVisible}
        title={intl.formatMessage(messages.lockUser)}
        text={<FormattedMessage {...messages.lockUserConfirmationText} />}
        confirmLabel={
          lockPublisherMutation.isPending ? (
            <FormattedMessage {...appMessages.loading} />
          ) : (
            <FormattedMessage {...messages.lockConfirmationButton} />
          )
        }
        cancelLabel={<FormattedMessage {...messages.lockConfirmationCancel} />}
        onCancel={() => setIsConfirmationDialogVisible(false)}
        onConfirm={() =>
          lockPublisherMutation.mutate({ id: props.publisherId })
        }
      />
    </>
  );
};

export default LockButton;
